import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Page, ItemsList, Icon, Spinner, Button } from 'components';
import UserContext from 'context/UserContext';
import PreviewContext from 'context/PreviewContext';
import useReactRouter from 'use-react-router';
import { useMutation } from '@apollo/react-hooks';
import { faPlus } from '@fortawesome/fontawesome-pro-solid';
import _ from 'lodash';
import { Loading, Toast, Modal } from '@shopify/app-bridge-react';
import { SWITCH_CAMPAIGN_STATUS, REMOVE_CAMPAIGN_MUTATION } from 'lib/mutations';
import { LIST_SHOP_CAMPAIGNS } from 'Queries';
import { BOX_CHECK_ICON, CAMPAIGN_TARGETS, BREAK_POINTS } from 'lib/globals';
import classNames from 'lib/classNames';
import ShopContext from 'context/ShopContext';
import API from '@aws-amplify/api';
import { Popover } from 'react-tiny-popover';
import { useQuery } from '@apollo/react-hooks';
import { trackMixPanelEvent } from 'lib/mixpanel';
import styles from 'styles/tutorial.module.scss';

const List = ({ setIsOpen }) => {
    const limitCampaigns = 35;
    const [, updateState] = useState();
    const [analytics, setAnalytics] = useState([]);
    const [popovers, setPopOvers] = useState({});
    const showPopOver = (id) => setPopOvers(Object.assign({}, popovers, { [id]: true }));
    const hidePopOver = (id) => setPopOvers(Object.assign({}, popovers, { [id]: false }));
    const forceUpdate = useCallback(() => updateState({}), []);
    const user = useContext(UserContext);
    const { collapsed, previewCampaign, preview_active_campaign } = useContext(PreviewContext);
    const shopContext = useContext(ShopContext);
    const {
        AppLocalStorage,
        state: {
            id: shopName,
            settings: { multiCurrencyMode },
            money_format
        }
    } = shopContext;
    const killDraftBreakPoint = BREAK_POINTS['kill_draft'](shopContext);

    const { history, location } = useReactRouter();
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? decimal + parts[1] : '';

        return dollars + cents;
    };
    const formatMoney = (n) => {
        n *= 100;
        return money_format
            .replace(/{{\s*?amount\s*?}}/g, formatWithDelimiters(n, 2))
            .replace(/{{\s*?amount_no_decimals\s*?}}/g, formatWithDelimiters(n, 0))
            .replace(
                /{{\s*?amount_with_comma_separator\s*?}}/g,
                formatWithDelimiters(n, 2, '.', ',')
            )
            .replace(
                /{{\s*?amount_no_decimals_with_comma_separator\s*?}}/g,
                formatWithDelimiters(n, 0, '.', ',')
            )
            .replace(
                /{{\s*?amount_with_apostrophe_separator\s*? }}/g,
                formatWithDelimiters(n, 2, "'", '.')
            );
    };
    const numberFormat = new Intl.NumberFormat('en-US', {
        maximumSignificantDigits: 3
    }).format;
    let {
        data: ListCampaignsData,
        loading: queryLoading,
        error: queryError,
        fetchMore
    } = useQuery(LIST_SHOP_CAMPAIGNS, {
        variables: {
            userId: user.attributes.sub
        },
        fetchPolicy: shopName === 'tentsile.myshopify.com' ? 'no-cache' : 'cache-and-network'
    });
    let [
        SetCampaignActiveMutation,
        {
            loading: SetCampaignActiveMutation_loading,
            error: SetCampaignActiveMutation_error,
            data: SetCampaignActiveMutation_data
        }
    ] = useMutation(SWITCH_CAMPAIGN_STATUS);
    let [
        RemoveCampaignMutation,
        {
            loading: RemoveCampaignMutation_loading,
            error: RemoveCampaignMutation_error,
            data: RemoveCampaignMutation_data
        }
    ] = useMutation(REMOVE_CAMPAIGN_MUTATION);
    const setCampaignActive = (id, active) => {
        SetCampaignActiveMutation({
            variables: { id, input: { active } },
            update: (cache, { data: { updateCampaign } }) => {
                cache.writeQuery({
                    query: LIST_SHOP_CAMPAIGNS,
                    variables: {
                        userId: user.attributes.sub
                    },
                    data: {
                        campaigns: {
                            list: ListCampaignsData.campaigns.list.map((campaign) => {
                                if (campaign.id === id) {
                                    return updateCampaign;
                                }
                                return campaign;
                            }),
                            nextToken: ListCampaignsData.campaigns.nextToken,
                            __typename: ListCampaignsData.campaigns.__typename
                        }
                    }
                });
            }
        });
    };
    const confirmDelete = (id) => {
        setShowConfirmDelete(id); //store campaign id
    };

    const isBeingPreviewed = (campaign) => campaign == preview_active_campaign && !collapsed;

    const edit = (id) => history.push(`/campaigns/${id}` + location.search);
    const duplicate = (id) => {
        if (ListCampaignsData?.campaigns?.list.length >= limitCampaigns) {
            console.log('limited');
        } else {
            history.push(`/campaigns/create/${id}` + location.search);
        }
    };

    const handleNewCampaign = () => {
        if (!AppLocalStorage.getItem('first_new_campaign_click')) {
            AppLocalStorage.setItem('first_new_campaign_click', true);
            trackMixPanelEvent('First new campaign click', shopName);
        }
        if (ListCampaignsData?.campaigns?.list.length >= limitCampaigns) {
            console.log('limited');
        } else {
            history.push('campaigns/create' + location.search);
        }
    };

    useEffect(() => {
        if (SetCampaignActiveMutation_data) {
            let index = _.findIndex(ListCampaignsData?.campaigns?.list, {
                id: SetCampaignActiveMutation_data.updateCampaign.id
            });
            ListCampaignsData.campaigns.list[index] = SetCampaignActiveMutation_data.updateCampaign;
            forceUpdate();
        }
    }, [SetCampaignActiveMutation_data]);

    useEffect(() => {
        if (RemoveCampaignMutation_data) {
            ListCampaignsData.campaigns.list = ListCampaignsData?.campaigns?.list.filter(
                ({ id }) => id !== RemoveCampaignMutation_data.removeCampaign.id
            );
            forceUpdate();
        }
    }, [RemoveCampaignMutation_data]);

    const fetchStatistics = async (campaigns) => {
        const campaigns_list = campaigns
            .filter(({ settings }) => settings?.type !== 'one_check_up_sell')
            .map(({ id }) => id);
        const one_tick_campaigns = campaigns
            .filter(({ settings }) => settings?.type === 'one_check_up_sell')
            .map(({ id, settings }) => {
                const isOld_OCU = !settings.multi_one_check_upsell;
                if (isOld_OCU)
                    return [
                        id,
                        settings?.one_check_up_sell?.product?.id,
                        settings?.one_check_up_sell?.product?.variants[0].price
                    ];
                return settings.multi_one_check_upsell.products
                    .filter(({ product }) => Boolean(product?.id))
                    .map(({ product }) => [id, product?.id, product?.variants[0].price]);
            })
            .reduce((acc, cur) => {
                if (Array.isArray(cur[0])) {
                    cur.forEach((v) => acc.push(v));
                } else {
                    acc.push(cur);
                }
                return acc;
            }, []);
        const body = {
            campaigns: campaigns_list,
            one_tick_campaigns
        };
        const data = await API.post('API_GATEWAY_NEW', '/analytics/campaigns', {
            body
        });
        const processedData = Object.assign(
            {},
            ...Object.entries(data).map(([id, states]) => {
                if (Array.isArray(states)) {
                    const { UpsellsGenerated, upsellsTotalAmount } = states.reduce(
                        (acc, cur) => {
                            acc.UpsellsGenerated += cur.UpsellsGenerated;
                            acc.upsellsTotalAmount += cur.upsellsTotalAmount;
                            return acc;
                        },
                        { UpsellsGenerated: 0, upsellsTotalAmount: 0 }
                    );
                    return { [id]: { UpsellsGenerated, upsellsTotalAmount } };
                }
                return { [id]: states };
            })
        );
        setAnalytics(processedData);
    };
    const callLoadMore = () => {
        fetchMore({
            variables: {
                userId: user.attributes.sub,
                nextToken: ListCampaignsData?.campaigns?.nextToken
            },
            updateQuery(previousResult, { fetchMoreResult }) {
                if (!fetchMoreResult) return previousResult;
                return {
                    campaigns: {
                        __typename: fetchMoreResult.campaigns.__typename,
                        nextToken: fetchMoreResult.campaigns.nextToken,
                        list: [...previousResult.campaigns.list, ...fetchMoreResult.campaigns.list]
                    }
                };
            }
        });
    };
    useEffect(() => {
        if (ListCampaignsData) {
            fetchStatistics(ListCampaignsData.campaigns.list);
        }
    }, [ListCampaignsData]);

    if (queryError || SetCampaignActiveMutation_error || RemoveCampaignMutation_error) {
        throw new Error(
            JSON.stringify({
                queryError,
                SetCampaignActiveMutation_error,
                RemoveCampaignMutation_error
            })
        );
    }

    return (
        <>
            {(SetCampaignActiveMutation_loading || RemoveCampaignMutation_loading) && <Loading />}
            {SetCampaignActiveMutation_data && (
                <Toast
                    content={`Campaign has been updated`}
                    duration={3000}
                    onDismiss={() => {
                        SetCampaignActiveMutation_data = null;
                    }}
                />
            )}
            {RemoveCampaignMutation_data && (
                <Toast
                    content={`Campaign has been removed`}
                    duration={3000}
                    onDismiss={() => {
                        RemoveCampaignMutation_data = null;
                    }}
                />
            )}
            <Page
                header={{
                    title: 'Campaign Dashboard',
                    actions: [
                        {
                            type: 'link-info',
                            text: 'New Campaign',
                            icon: faPlus,
                            onClick: handleNewCampaign
                        }
                    ]
                }}
                loading={{
                    text: 'Fetching campaigns',
                    status: queryLoading && !ListCampaignsData?.campaigns?.list.length
                }}
            >
                <ItemsList
                    header={[
                        {
                            title: 'Active',
                            onChange: ({ id }, active) => setCampaignActive(id, active)
                        },
                        {
                            title: 'Campaign',
                            value: (campaign) => {
                                const {
                                    name,
                                    settings: { type, add_to_unlock, one_check_up_sell },
                                    target
                                } = campaign;
                                const isGlobalBundles =
                                    type === 'bundles' && target.type === 'all_products';
                                const isMonsterFreeShippingAddToUnlock =
                                    type === 'add_to_unlock' &&
                                    add_to_unlock?.goals?.length === 1 &&
                                    add_to_unlock?.goals[0].reward_type === 'free_shipping' &&
                                    add_to_unlock?.goals[0].free_shipping.manual === false;
                                const isVirtualOneCheck =
                                    type === 'one_check_up_sell' &&
                                    one_check_up_sell?.product_type === 'hidden';

                                const isNotDelivering =
                                    multiCurrencyMode && (isGlobalBundles || isVirtualOneCheck);

                                return (
                                    <div className={classNames('px-2')}>
                                        <h2
                                            className={classNames(
                                                'font-bold text-gray-700 text-sm'
                                            )}
                                        >
                                            {campaign.name}
                                        </h2>
                                        {isNotDelivering && (
                                            <div className={classNames('mt-1 text-gray text-xs')}>
                                                <h4
                                                    className={classNames(
                                                        'font-semibold flex items-center text-orange-500 leading-none'
                                                    )}
                                                >
                                                    <Icon
                                                        icon="exclamation-square"
                                                        className="mr-1"
                                                        size="lg"
                                                    />
                                                    Not delivering
                                                </h4>
                                                <p className={classNames('text-gray-600')}>
                                                    due to 16th May checkout upgrade. Please edit
                                                    this campaign to fix this.
                                                    <a
                                                        className={classNames(
                                                            'ml-2 underline cursor-pointer font-semibold'
                                                        )}
                                                        href="https://monsterapps.crisp.help/en/article/draft-checkout-removed-16th-may-update-de3y6j/"
                                                        target="_blank"
                                                    >
                                                        Learn More
                                                    </a>
                                                </p>
                                            </div>
                                        )}
                                        {isMonsterFreeShippingAddToUnlock && (
                                            <div className={classNames('mt-1 text-gray text-xs')}>
                                                <h4
                                                    className={classNames(
                                                        'font-semibold flex items-center text-orange-500 leading-none'
                                                    )}
                                                >
                                                    <Icon
                                                        icon="exclamation-square"
                                                        className="mr-1"
                                                        size="lg"
                                                    />
                                                    Out of date
                                                </h4>
                                                <p className={classNames('text-gray-600')}>
                                                    This add to unlock version is out of date.
                                                    Please make new campaign.
                                                    {/* <a
														className={classNames(
															"ml-2 underline cursor-pointer font-semibold"
														)}
														href="https://monsterapps.crisp.help/en/article/draft-checkout-removed-16th-may-update-de3y6j/"
														target="_blank"
													>
														Learn More
													</a> */}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                );
                            }
                        },
                        // { title: 'Name' },
                        {
                            title: 'Type',
                            value: (campaign) => {
                                switch (campaign.settings.type) {
                                    case 'bundles':
                                        return (
                                            <div className={classNames('flex items-center')}>
                                                <span className={classNames('mr-1 primary-icon')}>
                                                    <Icon icon="bars" />
                                                </span>
                                                <span className={classNames('hidden-sm')}>
                                                    Buy More Save More
                                                </span>
                                            </div>
                                        );
                                    case 'add_to_unlock':
                                        return (
                                            <div className={classNames('flex items-center')}>
                                                <span className={classNames('mr-1 primary-icon')}>
                                                    <Icon icon="unlock" />
                                                </span>
                                                <span className={classNames('hidden-sm')}>
                                                    Add To Unlock
                                                </span>
                                            </div>
                                        );
                                    case 'one_check_up_sell':
                                        return (
                                            <div className={classNames('flex items-center')}>
                                                <span className={classNames('mr-1 primary-icon')}>
                                                    <Icon icon={BOX_CHECK_ICON} />
                                                </span>
                                                <span className={classNames('hidden-sm')}>
                                                    One Check Upsell
                                                </span>
                                            </div>
                                        );
                                    default:
                                        return null;
                                }
                            }
                        },
                        {
                            title: 'Campaign Trigger',
                            value: (campaign) =>
                                CAMPAIGN_TARGETS.find(({ value }) => value === campaign.target.type)
                                    .label
                        },
                        // { title: "Created At", value: "createdAt" },
                        // { title: "Updated At", value: "updatedAt" },
                        {
                            title: 'Upsells #',
                            value: (campaign) =>
                                analytics ? (
                                    numberFormat(analytics[campaign.id]?.UpsellsGenerated || 0)
                                ) : (
                                    <Spinner size={3} />
                                )
                        },
                        {
                            title: 'Revenue',
                            value: (campaign) => {
                                if (!analytics) return <Spinner size={3} />;
                                if (!analytics[campaign.id])
                                    return (
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: formatMoney(0)
                                            }}
                                        />
                                    );
                                const data = analytics[campaign.id];
                                const revenue = data?.upsellsTotalAmount || 0;

                                // if (campaign.settings.type !== "add_to_unlock")
                                return (
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: formatMoney(revenue)
                                        }}
                                    />
                                );

                                // const fbt_sub_total = data?.fbt?.subtotal_sum || 0;
                                // const fbt_upsells_generated = data?.fbt?.UpsellsGenerated || 0;
                                // return (
                                //   <Popover
                                //     isOpen={popovers[campaign.id] || false}
                                //     // positions={["center", "center"]}
                                //     padding={10}
                                //     reposition={false}
                                //     onClickOutside={() => hidePopOver(campaign.id)}
                                //     content={() => (
                                //       <div className="campaigns-popover">
                                //         <h2>FBT Module</h2>
                                //         <div className="flex-container">
                                //           <div>
                                //             <h4>Products Added</h4>
                                //             <p>{fbt_upsells_generated}</p>
                                //           </div>
                                //           <div>
                                //             <h4>Revenue Added</h4>
                                //             <p
                                //               dangerouslySetInnerHTML={{
                                //                 __html: formatMoney(fbt_sub_total)
                                //               }}
                                //             />
                                //           </div>
                                //         </div>
                                //       </div>
                                //     )}
                                //   >
                                //     <span
                                //       className="campaigns-popover-trigger"
                                //       onMouseEnter={() => showPopOver(campaign.id)}
                                //       onMouseLeave={() => hidePopOver(campaign.id)}
                                //     >
                                //       <span
                                //         dangerouslySetInnerHTML={{
                                //           __html: formatMoney(revenue)
                                //         }}
                                //       />{" "}
                                //       <Icon
                                //         icon="info-circle"
                                //         className="campaigns-popover-info"
                                //         size="sm"
                                //       />
                                //     </span>
                                //   </Popover>
                                // );
                            }
                        },

                        { title: 'Actions' }
                    ]}
                    actions={[
                        {
                            name: 'Preview',
                            icon: (campaign) => (isBeingPreviewed(campaign) ? 'eye-slash' : 'eye'),
                            color: (campaign) =>
                                isBeingPreviewed(campaign) ? 'primary' : 'secondary',
                            method: (campaign) => previewCampaign(campaign)
                        },
                        {
                            name: 'Duplicate',
                            icon: 'clone',
                            color: 'success',
                            method: ({ id }) => duplicate(id),
                            disabled: (campaign) => {
                                const {
                                    settings: { type, add_to_unlock }
                                } = campaign;
                                const isMonsterFreeShippingAddToUnlock =
                                    type === 'add_to_unlock' &&
                                    add_to_unlock?.goals?.length === 1 &&
                                    add_to_unlock?.goals[0].reward_type === 'free_shipping' &&
                                    add_to_unlock?.goals[0].free_shipping.manual === false;
                                return isMonsterFreeShippingAddToUnlock;
                            }
                        },
                        {
                            name: 'Edit',
                            icon: 'pencil-alt',
                            color: 'warning',
                            method: ({ id }) => edit(id),
                            disabled: (campaign) => {
                                const {
                                    settings: { type, add_to_unlock }
                                } = campaign;
                                const isMonsterFreeShippingAddToUnlock =
                                    type === 'add_to_unlock' &&
                                    add_to_unlock?.goals?.length === 1 &&
                                    add_to_unlock?.goals[0].reward_type === 'free_shipping' &&
                                    add_to_unlock?.goals[0].free_shipping.manual === false;
                                return isMonsterFreeShippingAddToUnlock;
                            }
                        },
                        {
                            name: 'Remove',
                            icon: 'trash',
                            color: 'danger',
                            method: ({ id }) => confirmDelete(id)
                        }
                    ]}
                    items={ListCampaignsData?.campaigns?.list || []}
                    emptyState={{
                        action: {
                            text: 'New Campaign',
                            url: '/campaigns/create'
                        },
                        text: "You don't have any campaigns, Create you first campaign."
                    }}
                />

                {ListCampaignsData?.campaigns?.nextToken && (
                    <div className={classNames('p-2 text-center')}>
                        <Button
                            type="link-info"
                            loading={queryLoading && ListCampaignsData?.campaigns?.list.length}
                            text="Load More"
                            onClick={callLoadMore}
                        />
                    </div>
                )}
                <p
                    className={classNames(
                        'w-full cursor-pointer hover:underline flex-1 text-gray-600 text-md font-bold pt-6 mt-6 border-t'
                    )}
                    onClick={() => setIsOpen(true)}
                >
                    Need help setting up campaigns or want best practices? Click here
                </p>
            </Page>
            <Modal
                title="Deleting a campaign"
                message="Are you sure you want to delete this campaign"
                open={!!showConfirmDelete} //cast string id to string
                primaryAction={{
                    content: 'Delete',
                    destructive: true,
                    onAction: () => {
                        //call remove mutation
                        RemoveCampaignMutation({
                            variables: { id: showConfirmDelete },
                            update: (cache, { data: { removeCampaign } }) => {
                                cache.writeQuery({
                                    query: LIST_SHOP_CAMPAIGNS,
                                    variables: {
                                        userId: user.attributes.sub
                                    },
                                    data: {
                                        campaigns: {
                                            list: ListCampaignsData.campaigns.list.filter(
                                                ({ id }) => id !== removeCampaign.id
                                            ),
                                            nextToken: ListCampaignsData.campaigns.nextToken,
                                            __typename: ListCampaignsData.campaigns.__typename
                                        }
                                    }
                                });
                            }
                        });
                        setShowConfirmDelete(false);
                    }
                }}
                secondaryActions={[
                    {
                        content: 'Close',
                        onAction: () => setShowConfirmDelete(false)
                    }
                ]}
            />
        </>
    );
};

export default List;
